import { createContext } from 'react'

export const BudgetContext = createContext(null)

export const UPDATE_BUDGET_TYPE = {
  DEFAULT: 'default',
  TEMPORARY: 'temporary',
}
